import {Injectable} from '@angular/core';
import {NavFactory} from './nav.factory';
import {NavItemCodes} from '../../enums/nav-item-codes.enum';
import {PermissionArea} from '../../enums/permission-area.enum';
import {IconCode} from '../../enums/icon-code.enum';

@Injectable()
export class NavDocumentFactory extends NavFactory {

    protected static items = [
        {
            code: NavItemCodes.DOCUMENT_ADD,
            icon: IconCode.DOCUMENT_ADD,
            label: 'DOCUMENT.ADD',
            description: 'DOCUMENT.ADD',
            path: ['/admin/documents/add'],
            cy: 'document-add',
        },
        {
            code: NavItemCodes.DOCUMENT_EDIT,
            icon: IconCode.DOCUMENT_EDIT,
            label: 'DOCUMENT.EDIT',
            description: 'DOCUMENT.EDIT',
            path: (documentId) => ['/admin/documents', documentId]
        },
        {
            code: NavItemCodes.DOCUMENT_DELETE,
            icon: IconCode.DOCUMENT_DELETE,
            label: 'DOCUMENT.DELETE',
            description: 'DOCUMENT.DELETE',
        },
        {
            code: NavItemCodes.DOCUMENT_DOWNLOAD,
            icon: IconCode.DOCUMENT_DOWNLOAD,
            label: 'DOCUMENT.DOWNLOAD',
            description: 'DOCUMENT.DOWNLOAD',
        },
        {
            code: NavItemCodes.DOCUMENT_VIEW,
            icon: IconCode.DOCUMENT_VIEW,
            label: 'NAV.DOCUMENTS_SELLER.LABEL',
            description: 'NAV.DOCUMENTS_SELLER.DESC',
            path: '/documents',
            permissionArea: PermissionArea.DOCUMENTS_VIEW
        },
        {
            code: NavItemCodes.DOCUMENT_MANAGEMENT,
            icon: IconCode.DOCUMENT_MANAGEMENT,
            label: 'NAV.DOCUMENTS_ADMIN.LABEL',
            description: 'NAV.DOCUMENTS_ADMIN.DESC',
            path: '/admin/documents',
            permissionArea: PermissionArea.DOCUMENTS_MANAGEMENT,
            cy: 'document-management',
        },
    ];
}
